import { FC } from 'react';

import { Grid, Theme, Typography, useMediaQuery } from '@mui/material';

import Form from './Form';

interface Props {
  isForgotPassword?: boolean | null;
}

const ForgotAndPasswordReset: FC<Props> = ({ isForgotPassword }) => {
  const isSmallScreen = useMediaQuery<Theme>((theme) =>
    theme.breakpoints.down('sm'),
  );
  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      minHeight={'70vh'}
      spacing={2}
      css={{
        padding: '2.5rem 0.5rem',
      }}
    >
      <Grid>
        <Typography variant="h5" css={{ textAlign: 'center' }}>
          {isForgotPassword
            ? 'Need to reset your password?'
            : 'Reset My Password'}
        </Typography>
      </Grid>
      <Grid>
        <Typography variant="body1" css={{ textAlign: 'center' }}>
          {isForgotPassword &&
            `No sweat. Enter your account email address here, and we’ll send you instructions `}
          {!isSmallScreen && isForgotPassword && <br />}
          {isForgotPassword && 'to reset your password.'}
        </Typography>
      </Grid>
      <Grid>
        <Form isForgotPassword={isForgotPassword} />
      </Grid>
    </Grid>
  );
};

export default ForgotAndPasswordReset;
